import apiFetch from '../apiFetch'

export default function (idRaza, token) {
  return apiFetch({endPoint: `Raza/getRaza?idRaza=${idRaza}`, method: 'GET', body: null, token: token})
}
